export default "__VITE_ASSET__BwIJlOaM__"